// src/utils/dashboardNavigation.js
import { isHomePath } from './navHistory';

/**
 * Open the Dashboard from wherever the user currently is.
 *
 * When the user is on Home we open it as an **overlay** by stashing the
 * current location in `state.background`. App.jsx renders its primary
 * <Routes> against `state.background || location`, so Home stays mounted
 * underneath the whole time: its map, its fetched places, its scroll position
 * and every bit of component state survive untouched. Dismissing the overlay
 * is then a history pop that simply uncovers the still-live Home — no
 * remount, no refetch, no map re-initialisation.
 *
 * `/tour-guide` and `/login` already use this exact pattern.
 *
 * From anywhere else we navigate normally. Rendering, say, a profile page
 * behind the dashboard overlay would be wrong, and Home is not mounted there
 * to preserve anyway.
 *
 * Trade-off worth knowing: an overlay keeps Home alive in memory (and its map
 * ticking) while the dashboard is on top. That is the price of instant,
 * state-preserving return, and it is the same bargain /tour-guide already
 * makes. If idle cost ever matters, pause Home's map while it is covered
 * rather than going back to unmounting it.
 *
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {{pathname: string}} location current router location
 */
export function openDashboard(navigate, location) {
  if (location && isHomePath(location.pathname)) {
    navigate('/dashboard', { state: { background: location } });
    return;
  }
  navigate('/dashboard');
}

export default openDashboard;
